export class MediaFile {
  constructor(
    public id: string = "",
    public mimetype: string = "",
    public status: string = "",
    public name: string = "",
    public url: string = ""
  ) {}
}

export class MediaStatus {
  public static readonly DONE = "DONE";
  public static readonly FAIL = "FAIL";
  public static readonly WAITING = "WAITING";
}

export class MaterialStatus {
  public static readonly MANDATORY = "MANDATORY";
  public static readonly ADDITIONAL = "ADDITIONAL";
  public static readonly DETAILED = "DETAILED";
}
